// extracted by mini-css-extract-plugin
export default {"fondo":"Servicios_fondo__jo-YS"};